import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    setMenuOpen(false);
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToTop = () => {
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-gradient-to-b from-black/60 to-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-14 flex items-center justify-between h-16 md:h-20">

        {/* LOGO — inverted (white) over dark hero, natural color on white navbar */}
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); scrollToTop(); }}
          className="flex items-center cursor-pointer flex-shrink-0"
        >
          <img
            src="https://inspectors.com/wp-content/uploads/2022/01/logo.png"
            alt="Inspectors.com — Certified Home Inspections Nationwide"
            className="block object-contain"
            style={{ height: '36px', maxWidth: '180px', minWidth: '110px' }}
          />
        </a>

        {/* DESKTOP: phone + CTA */}
        <div className="hidden md:flex items-center gap-5">
          <a
            href="tel:+12814217355"
            className={`flex items-center gap-2 text-sm font-semibold transition-colors duration-200 whitespace-nowrap hover:text-[#C9A961] ${
              scrolled ? 'text-[#1A1A1A]' : 'text-white'
            }`}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-[#C9A961] text-xs"></i>
            </div>
            (281) 421-7355
          </a>
          <button
            onClick={scrollToContact}
            className="bg-[#C9A961] text-white text-sm font-semibold px-6 py-2.5 rounded-md hover:bg-[#b8944f] transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Schedule Inspection
          </button>
        </div>

        {/* MOBILE: call + hamburger */}
        <div className="md:hidden flex items-center gap-3">
          <a
            href="tel:+12814217355"
            className={`flex items-center gap-1.5 text-sm font-semibold whitespace-nowrap ${
              scrolled ? 'text-[#1A1A1A]' : 'text-white'
            }`}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-[#C9A961] text-xs"></i>
            </div>
            Call
          </a>
          <button
            className={`w-8 h-8 flex items-center justify-center cursor-pointer ${
              scrolled ? 'text-[#1A1A1A]' : 'text-white'
            }`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#1A1A1A]/8 px-6 py-5 flex flex-col gap-4">
          <div className="pb-3 border-b border-[#1A1A1A]/8">
            {/* Natural color logo on white mobile menu */}
            <img
              src="https://inspectors.com/wp-content/uploads/2022/01/logo.png"
              alt="Inspectors.com"
              className="block object-contain"
              style={{ height: '32px', maxWidth: '160px' }}
            />
          </div>
          <a
            href="tel:+12814217355"
            className="flex items-center gap-2 text-sm font-semibold text-[#1A1A1A]"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-[#C9A961] text-xs"></i>
            </div>
            (281) 421-7355
          </a>
          <button
            onClick={scrollToContact}
            className="bg-[#C9A961] text-white text-sm font-semibold px-5 py-3 rounded-md cursor-pointer whitespace-nowrap text-center"
          >
            Schedule Inspection
          </button>
        </div>
      )}
    </header>
  );
}
